import { Component, computed, input, output } from '@angular/core';
import { RidWord, TRidWord, getWord } from '../rid-word/rid-word';

@Component({
  selector: 'rid-word-list',
  imports: [RidWord],
  templateUrl: './rid-word-list.html',
})
export class RidWordList {
  words = input.required<(string | TRidWord)[]>();
  delay = input<number>(0);

  selectionChanged = output<{ kind: 'ADDED' | 'REMOVED'; index: number }>();

  wordMap = computed(() => {
    const map = new Map<number, ReturnType<typeof getWord>>();
    this.words().forEach((word, index) => {
      map.set(index, getWord(word));
    });
    return map;
  });
}
